import { IconAlert, IconRefresh, IconFileWarn } from "../icons";

interface Props {
  message: string;
  code?: string;
  onRetry?: () => void;
}

/**
 * Estado de erro amigável. Para erro de banco, mostra os passos DESTE sistema.
 *
 * As instruções antigas eram cópia do Operacional e mandavam configurar o banco
 * do Planejamento com `bun run db:setup` — um caminho que não existe aqui e que
 * levaria quem seguisse a mexer no banco errado. Este sistema lê o banco CENTRAL
 * `sercamp` (o mesmo do Portal) e cria sozinho as tabelas `dev_*` quando sobe.
 */
export default function ErrorState({ message, code, onRetry }: Props) {
  const isDb = code?.startsWith("DB_");

  return (
    <div className="error-state">
      <div className="error-icon">{isDb ? <IconFileWarn size={34} /> : <IconAlert size={34} />}</div>
      <h2>{isDb ? "Banco de dados não configurado" : "Algo deu errado"}</h2>
      <p className="error-msg">{message}</p>

      {isDb && (
        <div className="setup-box">
          <strong>Como resolver (PostgreSQL 17):</strong>
          <ol>
            <li>
              Este sistema usa o banco central do Portal: <code>sercamp</code>
            </li>
            <li>
              Confira a senha em <code>.env</code> → <code>DATABASE_URL</code>
            </li>
            <li>As tabelas próprias daqui (<code>dev_*</code>) são criadas sozinhas na subida</li>
            <li>Reinicie pelo orquestrador do Portal (nunca suba a porta 4012 à parte)</li>
          </ol>
        </div>
      )}

      {onRetry && (
        <button className="btn-primary" onClick={onRetry}>
          <IconRefresh size={16} /> Tentar novamente
        </button>
      )}
    </div>
  );
}
